import SolicitudBeneficio from "./SolicitudBeneficio";

export default SolicitudBeneficio;
